<script setup>
const props = defineProps({
  width: {
    type: Number,
    default: 160
  },
  height: {
    type: Number,
    default: 36
  },
  top: {
    type: Number,
    default: 0
  },
  left: {
    type: Number,
    default: 0
  },
  // 是否展示
  show: {
    type: Boolean,
    default: false
  }
})
</script>

<template>
  <div v-show="props.show" class="disabled_box son_box" :style="`width: ${props.width}px;height: ${props.height}px;top: ${props.top}px;left: ${props.left}px;`"></div>
  <div v-show="props.show" class="disabled_box_bg son_box" :style="`width: ${props.width}px;height: ${props.height}px;top: ${props.top}px;left: ${props.left}px;`"></div>
</template>

<style lang="scss" scoped>
.disabled_box {
  width: 160px;
  height: 36px;
  border-radius: 12px;
  border: 1px solid #ccc;
  z-index: 10;
  background: linear-gradient(
      to bottom right,
      transparent 49.5%,
      #ccc 50%,
      transparent 50.5%
  );
  cursor: not-allowed;
}
.disabled_box_bg {
  width: 160px;
  height: 36px;
  border-radius: 12px;
  border: 1px solid #ccc;
  background-color: #F1F1F1;
  z-index: 9;
  cursor: not-allowed;
}
</style>
